import { GuestTableFiltersActionTypes, GuestTableFiltersState, SET_GUEST_TABLE_FILTERS } from './types';

const defaultState: GuestTableFiltersState = {
  isLoading: false,
  errorMessage: '',
  contents: {},
  exists: false,
};

export default function guestTableFilters(state = defaultState, action: GuestTableFiltersActionTypes): GuestTableFiltersState {
  switch (action.type) {
    case SET_GUEST_TABLE_FILTERS:
      return { ...state, contents: action.contents, isLoading: false, exists: action.exists };
    default:
      return state;
  }
}
